var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/PLUpsell/PLUpsell.jsx";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { UpsellMixin, Card, TextButton, MediaObject, Trigger } from '@zillow/constellation';
import ContactAgentForm, { fetchAbadHtml, submitContact } from '@zillow/off-market-contact-agent-form';
/**
 * An Upsell is a type of [`Card`](#/More%20components?id=card) that uses imagery and text to
 * promote something.  Under the covers, it uses
 * [`MediaObject`](#/Layout%20components?id=mediaobject) to compose the imagery media
 * with the text content.
 * PL Upsell will show a modal if action link is empty
 */

var StyledCard = styled(Card).withConfig({
  displayName: "PLUpsell__StyledCard",
  componentId: "jj3kme-0"
})(["margin:", ";"], function (_ref) {
  var overrideMargin = _ref.overrideMargin;
  return "" + overrideMargin || "0px 16px 0px 16px";
});
var PLUpsell = styled(function (props) {
  var renderLayout = props.renderLayout;
  var content = renderLayout;

  if (typeof renderLayout === 'function') {
    content = renderLayout(Object.assign({}, props));
  } // Prevent prop bleed to DOM


  var direction = props.direction,
      media = props.media,
      rest = _objectWithoutProperties(props, ["direction", "media"]);

  return /*#__PURE__*/React.createElement(StyledCard, _extends({}, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 12
    }
  }), content);
}).withConfig({
  displayName: "PLUpsell",
  componentId: "jj3kme-1"
})(["", ""], UpsellMixin);
PLUpsell.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A [`Button`](#/Button%20components?id=button) node used as the primary call to action.
   */
  actionButton: PropTypes.node,

  /**
   * Customize the color of the upsell. When using a dark background, the text will be inverted.
   */
  background: PropTypes.oneOf(['backgroundBlue', 'backgroundWhite']),

  /**
   * A [`Text`](#/Typography%20components?id=text) node.
   */
  body: PropTypes.node,

  /**
   * By default, an upsell can be closed. Set this to `false` to disallow closing of the upsell.
   */
  closeable: PropTypes.bool,

  /**
   * The direction of the media to be used within the
   * [`MediaObject`](#/Layout%20components?id=mediaobject) component.
   */
  direction: PropTypes.oneOf(['row', 'column']),

  /**
   * A [`Heading`](#/Typography%20components?id=heading) node.
   */
  heading: PropTypes.node,

  /**
   * An [`Image`](#/More%20components?id=image) or [`Icon`](#/More%20components?id=icon) node.
   */
  media: PropTypes.node,

  /**
   * `renderLayout` can be used to modify the default composition of the component.
   * Pass your own node or pass a render function that receives enhanced
   * props as the only argument.
   */
  renderLayout: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * `showModal` is a flag that the parent component PLUpsellTemplate
   *  uses to interact and indicate if we should pop up the Partner Leads
   *  modal when action link is not configured.
   */
  showModal: PropTypes.bool,

  /**
   *  `additionalProps` is a hook within onsiteMessage react package as a way to pass
   *  in dependency objects in order to make an upsell fully functional.
   *  In the PL Upsell, we need to pass in AbadClient and zatlasEndpoint to fully enable
   *  the partner leads module and allow us to submit a lead.
   */
  additionalProps: PropTypes.shape({
    property: PropTypes.object,
    viewer: PropTypes.object,
    abadClient: PropTypes.func,
    zatlasEndpoint: PropTypes.string,
    shouldShowcheckBox: PropTypes.bool
  }),

  /**
   * Location of the message for GA tracking
   */
  gaLocation: PropTypes.string,

  /**
   * Surface of the message for GA tracking
   */
  gaSurface: PropTypes.string,

  /**
   * Treatment of the message for GA tracking
   */
  gaTreatment: PropTypes.string,

  /**
   * The margin value to adjust spacing around the upsell UI.
   * Enter value in the format: top right bottom left
   * Default value: 0px 16px 0px 16px
   */
  overrideMargin: PropTypes.string,

  /**
   * This trackingParameter indicates the lead source and lead type
   */
  trackingParameter: PropTypes.string
} : {};
PLUpsell.defaultProps = {
  background: 'blue100',
  cardType: 'secondary',
  cardElevation: 1,
  closeable: false,
  direction: 'row',
  heading: null,
  media: null,
  showModal: false,
  gaLocation: '',
  gaSurface: '',
  overrideMargin: '16px 16px 16px 16px',
  additionalProps: {},
  renderLayout: function renderLayout(_ref2) {
    var actionButton = _ref2.actionButton,
        body = _ref2.body,
        direction = _ref2.direction,
        heading = _ref2.heading,
        media = _ref2.media,
        showModal = _ref2.showModal,
        gaLocation = _ref2.gaLocation,
        gaSurface = _ref2.gaSurface,
        gaTreatment = _ref2.gaTreatment,
        trackingParameter = _ref2.trackingParameter,
        additionalProps = _ref2.additionalProps;
    var align = 'start';

    if (direction === 'column') {
      align = 'center';
    }

    var property = additionalProps.property,
        viewer = additionalProps.viewer,
        abadClient = additionalProps.abadClient,
        zatlasEndpoint = additionalProps.zatlasEndpoint,
        shouldShowcheckBox = additionalProps.shouldShowcheckBox;
    var action = /*#__PURE__*/React.createElement(TextButton, _extends({}, actionButton.props, {
      buttonType: "secondary",
      style: {
        color: '#006AFF',
        borderColor: '#006AFF',
        display: 'block',
        minWidth: '120px'
      },
      inverse: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 155,
        columnNumber: 13
      }
    })); // If actionLink is absent, PLUpsellWrapper sends this as true

    if (showModal) {
      action = /*#__PURE__*/React.createElement(Trigger, {
        onOpen: function onOpen() {},
        triggered: function triggered(modalProps, close) {
          return /*#__PURE__*/React.createElement(ContactAgentForm, {
            modalDialogProps: Object.assign(Object.assign({}, modalProps), {}, {
              mediaQuery: {
                xs: {
                  fullScreen: true
                },
                md: {
                  fullScreen: false
                }
              },
              wide: true
            }),
            shouldSuggestCloseOnSuccess: true,
            property: property,
            viewer: viewer,
            zatlasEndpoint: zatlasEndpoint,
            showCheckBox: shouldShowcheckBox,
            centerAlignedNote: true,
            onClose: close,
            page: gaSurface,
            location: gaLocation,
            treatment: gaTreatment,
            abadClient: abadClient,
            onSubmit: function onSubmit(params) {
              return new Promise(function ($return, $error) {
                return $return(submitContact(params));
              });
            },
            onFetchAbadHtml: function onFetchAbadHtml(params) {
              return new Promise(function ($return, $error) {
                return $return(fetchAbadHtml(params));
              });
            },
            trackingParam: trackingParameter,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 173,
              columnNumber: 25
            }
          });
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 170,
          columnNumber: 17
        }
      }, action);
    }

    return /*#__PURE__*/React.createElement(MediaObject, {
      media: media,
      direction: direction,
      align: align,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 204,
        columnNumber: 13
      }
    }, heading, body, action);
  }
};
export default PLUpsell;